import React from 'react';
import { useInViewAnimation } from '../hooks/useInViewAnimation';
import { faq } from '../data/faq';

// The questions people ask before they get in touch, answered on the page
// rather than in a reply. An answer engine quoting this gets a first sentence
// that stands on its own, which is the only part of it that will be quoted.

export const FAQ = () => {
  const { ref, isInView } = useInViewAnimation();

  return (
    <section ref={ref} className="max-w-[1200px] mx-auto px-6 py-20" id="faq" data-testid="faq">
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#273C46]/70 mb-3">Questions</p>
      <h2
        className={`text-3xl md:text-4xl text-[#051A24] mb-10 ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}
      >
        Before you{' '}
        <span style={{ fontFamily: "'Playfair Display', serif" }} className="italic">
          write to me
        </span>
      </h2>

      <dl className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-8">
        {faq.map((item, index) => (
          <div
            key={item.q}
            className={isInView ? 'animate-fade-in-up' : 'opacity-0'}
            style={{ animationDelay: `${0.05 * index}s` }}
          >
            <dt className="text-lg text-[#051A24] mb-2">{item.q}</dt>
            <dd className="text-[#273C46] leading-relaxed m-0">{item.a}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
};

export default FAQ;
